import * as z from 'zod'
import {LabelColors} from '@primer/react-brand'

import {buildEntrySchemaFor} from '../entry'
import {AppStoreButtonSchema} from './appStoreButton'
import {AssetSchema} from './asset'
import {LinkSchema} from './link'
import {PrimerComponentLabelSchema} from './primerComponentLabel'
import {AnimatedVideoSchema} from './animatedVideo'
import {RichTextSchema} from '../richText'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentHeroSchema = buildEntrySchemaFor('primerComponentHero', {
  fields: z.lazy(() =>
    z.object({
      align: z.literal('start').or(z.literal('center')),
      label: safeOptional(z.union([z.string(), PrimerComponentLabelSchema])),
      labelColor: z.enum(LabelColors).optional(), // Deprecated
      increaseLabelContrast: z.boolean().optional(),
      heading: z.string(),
      headingSize: z.enum(['1', '2', '3', 'display']).optional(),
      image: safeOptional(AssetSchema),
      imagePosition: z.literal('Block').or(z.literal('Inline')).optional(),
      videoSrc: z.string().optional(),
      animatedVideo: safeOptional(AnimatedVideoSchema),
      description: z.string().optional(),
      descriptionRich: safeOptional(RichTextSchema),
      descriptionVariant: z.enum(['default', 'muted']).optional(),
      callToActionPrimary: safeOptional(LinkSchema),
      callToActionPrimaryVariant: z.enum(['primary', 'accent']).optional(), // Deprecated
      callToActionSecondary: safeOptional(LinkSchema),
      trailingComponent: safeOptional(z.array(AppStoreButtonSchema)),
      nt_experiences: safeOptional(z.array(z.any())),
    }),
  ),
})

export type PrimerComponentHero = z.infer<typeof PrimerComponentHeroSchema>
